"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _interactionsReducer = _interopRequireDefault(require("./interactionsReducer"));

var _settingsReducer = _interopRequireDefault(require("./settingsReducer"));

var _domainsReducer = _interopRequireDefault(require("./domainsReducer"));

var _subdomainsReducer = _interopRequireDefault(require("./subdomainsReducer"));

var _analyticsViewsReducer = _interopRequireDefault(require("./analyticsViewsReducer"));

var _trackingCodeReducer = _interopRequireDefault(require("./trackingCodeReducer"));

var _ipReducer = _interopRequireDefault(require("./ipReducer"));

var _customJSReducer = _interopRequireDefault(require("./customJSReducer"));

var _default = (0, _redux.combineReducers)({
  interactions: _interactionsReducer.default,
  settings: _settingsReducer.default,
  domains: _domainsReducer.default,
  subdomains: _subdomainsReducer.default,
  analyticsViews: _analyticsViewsReducer.default,
  trackingCode: _trackingCodeReducer.default,
  ip: _ipReducer.default,
  customJS: _customJSReducer.default
});

exports.default = _default;
module.exports = exports.default;